"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NestableDef = void 0;
const tslib_1 = require("tslib");
const t = tslib_1.__importStar(require("io-ts"));
const BooleanDef_1 = require("./BooleanDef");
const ColorDef_1 = require("./ColorDef");
const DateDef_1 = require("./DateDef");
const EmbedDef_1 = require("./EmbedDef");
const GeoPointDef_1 = require("./GeoPointDef");
const ImageDef_1 = require("./ImageDef");
const IntegrationFieldDef_1 = require("./IntegrationFieldDef");
const LinkDef_1 = require("./LinkDef");
const NumberDef_1 = require("./NumberDef");
const RangeDef_1 = require("./RangeDef");
const RichTextDef_1 = require("./RichTextDef");
const SelectDef_1 = require("./SelectDef");
const SeparatorDef_1 = require("./SeparatorDef");
const TextDef_1 = require("./TextDef");
const TimestampDef_1 = require("./TimestampDef");
exports.NestableDef = t.union([
    BooleanDef_1.BooleanDef,
    ColorDef_1.ColorDef,
    DateDef_1.DateDef,
    EmbedDef_1.EmbedDef,
    GeoPointDef_1.GeoPointDef,
    ImageDef_1.ImageDef,
    IntegrationFieldDef_1.IntegrationFieldDef,
    NumberDef_1.NumberDef,
    RangeDef_1.RangeDef,
    RichTextDef_1.RichTextDef,
    SelectDef_1.SelectDef,
    SeparatorDef_1.SeparatorDef,
    TextDef_1.TextDef,
    TimestampDef_1.TimestampDef,
    LinkDef_1.LinkDef,
]);
